import React from "react";

function formatINR(num) {
  try {
    return num.toLocaleString("en-IN");
  } catch {
    return num;
  }
}

export default function TariffPlan({
  plans = [
    { title: "1 Sharing Room", price: 10000, period: "Month", includes: "including breakfast and dinner" },
    { title: "2 Sharing Room", price: 9000,  period: "Month", includes: "including breakfast and dinner" },
    { title: "3 Sharing Room", price: 8000,  period: "Month", includes: "including breakfast and dinner" },
  ],
  note = "Note : Rs.7000 deposit for all & one month advance Payment",
  foodTimes = "Foods Time : Breakfast 8.00am to 9 am & Dinner 8pm to 9pm",
  showHeading = false,
  heading = "Tariff Plan",
}) {
  return (
   <>
   <section
      className="page-title"
      style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
    >
      <div className="auto-container">
        <h1>Tariff Plan</h1>
       
      </div>
    </section>


    <section className="tariff-section ">
        <h3 className="error-section">Transparent Pricing for Your Stay
Find the Perfect Plan for Your Needs.</h3>
      <div className="auto-container">
        {showHeading && <h2 className="tariff-heading">{heading}</h2>}

        <div className="tariff-list">
          {plans.map((p, i) => (
            <article className="tariff-card" key={i}>
              <h3 className="tariff-title">{p.title}</h3>
              <div className="tariff-price">
                <span className="currency">Rs.</span>
                {formatINR(p.price)}
                <span className="period">/{p.period}</span>
              </div>
              {p.includes && <div className="tariff-includes">({p.includes})</div>}
            </article>
          ))}
        </div>

        <div className="tariff-note">
          <p>{note}</p>
          <p className="food-time">{foodTimes}</p>
        </div>
      </div>
    </section>
   </>
  );
}
